var render = function render(){var _vm=this,_c=_vm._self._c;return _c('validation-errors',{attrs:{"attribute":_vm.id,"validation-errors":_vm.errors}})
}
var staticRenderFns = []

export { render, staticRenderFns }